<!--
	lovi 银行卡管理
	2019-12-31
-->
<template>
  <div>
    <div class="breadcrumb-wrap">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/">{{ $t("common.eepay") }}</BreadcrumbItem>
        <BreadcrumbItem>{{ $t("wallet.bankCard") }}</BreadcrumbItem>
      </Breadcrumb>
      <a class="returnA" @click="returnFun" v-if="verifyFlag || bindCardFlag">
        {{ $t("common.back") }}
      </a>
    </div>
    <!-- 安全验证 -->
    <verify
      v-if="verifyFlag"
      :verifyFlag.sync="verifyFlag"
      :bindCardFlag.sync="bindCardFlag"
    />
    <!-- 绑卡 -->
    <bind-card
      v-else-if="bindCardFlag"
      @getBankCardList="getBankCardList"
      :editBankId="editBankId"
      :bindCardFlag.sync="bindCardFlag"
    />

    <!-- 银行卡管理 -->
    <div v-else>
      <div class="add-bank">
        <Button type="primary" @click="verifyFlag = true">
          {{ $t("common.add") }}
        </Button>
      </div>
      <div class="bank-wrap">
        <div class="no-bank" v-if="!bankCardList.length && bankListFlag">
          <img src="@/assets/images/wallet/pic_yinhangka.png" alt="" />
          <p>{{ $t("common.noData") }}</p>
        </div>
        <template v-if="bankCardList.length && bankListFlag">
          <div
            class="bank-list"
            :class="`banktype${item.country}`"
            v-for="(item, index) in bankCardList"
            :key="index"
          >
            <div class="info-wrap">
              <div class="info">
                <h3>
                  <span>{{ item.bank_name }}</span>
                </h3>
                <h4>{{ item.card_number }}</h4>
              </div>
            </div>
            <div class="btn-wrap">
              <Button type="primary" @click="editBank(item)">
                {{ $t("common.edit") }}
              </Button>
              <Button type="primary" @click="deleteBank(item.id)">
                {{ $t("common.delete") }}
              </Button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Verify from "./verify";
import BindCard from "./bindCard";
export default {
  name: "wallet-bankCard",
  components: {
    Verify,
    BindCard
  },
  data() {
    return {
      verifyFlag: false,
      bindCardFlag: false, //银行卡Flag
      bankCardList: [], //银行卡列表

      bankListFlag: false,

      editBankId: 0 //编辑银行卡Id
    };
  },
  created() {
    this.getBankCardList();
  },
  mounted() {},
  computed: {},
  methods: {
    returnFun() {
      // 返回
      this.verifyFlag = false;
      this.bindCardFlag = false;
    },
    editBank(data) {
      // 编辑银行卡
      let vm = this;
      vm.verifyFlag = true;
      vm.editBankId = data.id;
    },
    deleteBank(id) {
      // 删除银行卡
      this.$Modal.confirm({
        title: this.$t("common.sureRemoveBinding"),
        onOk: () => {
          this.unbindBankCard(id);
        },
        onCancel: () => {}
      });
    },
    unbindBankCard(id) {
      // 解除绑定
      let vm = this;
      vm.$post(
        "/app/bankcard/unbindBankCard",
        { id: id },
        { alert: true }
      ).then(res => {
        console.log(res, "unbindBankCard");
        if (res.code == 0) {
          vm.$Message.success(res.msg);
          vm.getBankCardList();
        } else {
          vm.$Message.error(res.msg);
        }
      });
    },
    getBankCardList() {
      // 获取银行卡列表
      let vm = this;
      vm.bankListFlag = false;
      vm.$post("/app/bankcard/bankCardList", {}, { loading: true }).then(
        res => {
          console.log("bankCardList", res);
          vm.bankListFlag = true;
          vm.bankCardList = res.list;
        }
      );
    }
  },
  watch: {
    bindCardFlag(bol) {
      if (bol == false) {
        this.editBankId = 0;
      }
    }
  },
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.bank-wrap {
  padding: 0 30px;
}
.add-bank {
  padding: 20px 30px;
}
button {
  padding: 0 25px;
  height: 36px;
  font-size: 16px;
}
.no-bank {
  margin: 35px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
  }
  p {
    font-size: 24px;
    color: #999999;
    margin-top: 30px;
  }
}
.bank-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid rgba(201, 201, 201, 0.5);
  .btn-wrap {
    button {
      margin-left: 10px;
    }
  }
  .info-wrap {
    width: 360px;
    height: 160px;
    // width: 220px;
    overflow: hidden;
    padding: 30px 40px;
    background-image: url("@{imgUrl}wallet/pic_card1@2x.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    .info {
      // padding: 10px;
      color: #fff;
      h3 {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 24px;
        font-weight: 500;
        font-size: 20px;
        img {
          margin-right: 10px;
          height: 24px;
        }
      }
      h4 {
        margin-top: 20px;
        font-weight: 500;
        line-height: 30px;
        font-size: 18px;
      }
    }
    .bottom {
      height: 16px;
      background: #2042ab;
    }
  }
  &.banktype1 {
    .info-wrap {
      background-image: url("@{imgUrl}wallet/pic_card1@2x.png");
    }
    /deep/.ivu-btn-primary {
      background: linear-gradient(
        270deg,
        rgba(223, 101, 83, 1) 0%,
        rgba(255, 160, 0, 1) 100%
      );
    }
  }
  &.banktype2 {
    .info-wrap {
      background-image: url("@{imgUrl}wallet/pic_card2@2x.png");
    }
    /deep/.ivu-btn-primary {
      background: linear-gradient(
        90deg,
        rgba(50, 73, 195, 1) 0%,
        rgba(43, 58, 141, 1) 100%
      );
    }
  }
  &.banktype3 {
    .info-wrap {
      background-image: url("@{imgUrl}wallet/pic_card3@2x.png");
    }
    /deep/.ivu-btn-primary {
      background: linear-gradient(
        121deg,
        rgba(48, 182, 134, 1) 0%,
        rgba(62, 144, 186, 1) 100%
      );
    }
  }
}
</style>
